import type { DocumentUploadRequestDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	type DocumentUploadFormOutput,
	TITLE_MAX_LENGTH,
} from "web_myplann/Portfolio/Forms/DocumentUploadForm/documentUploadFormSchema";
import type { DocumentUploadOrigin } from "web_myplann/Portfolio/Helpers/documentUploadOrigin";
import { mapDocumentLinkToIds } from "web_myplann/Portfolio/Helpers/mapDocumentLinkToIds";
import { fileNameWithoutExtension } from "web_myplann/Shared/Utils/fileNameWithoutExtension";

type DocumentUploadRequest = DocumentUploadRequestDTO & { title: string };

export const mapDocumentUploadFormToRequest = (
	{ pickedFile, name, folder, linkedItem }: DocumentUploadFormOutput,
	origin: DocumentUploadOrigin,
): DocumentUploadRequest => {
	const link = origin.link ?? linkedItem?.link;

	return {
		file: pickedFile.file,
		title: (
			name ||
			fileNameWithoutExtension(pickedFile.filename) ||
			pickedFile.filename
		).slice(0, TITLE_MAX_LENGTH),
		tags: folder ? [folder] : undefined,
		...(link ? mapDocumentLinkToIds(link) : {}),
	};
};
